import { questionHasChildren } from "../../../../../../projection/question/question.typeguards";
const isIdIncludedInAnswers = ({ answerId, answers }) => Object.values(answers).some((answer) => answer.find((a) => answerId.includes(a)));
const filteredQuestionsByAnswers = ({ questions, answers }) => questions.reduce((acc, question) => {
    let newItem = { ...question };
    if (questionHasChildren(newItem)) {
        newItem = {
            ...newItem,
            // @ts-ignore
            children: filteredQuestionsByAnswers({ questions: newItem.children, answers }),
        };
    }
    if (
    // @ts-ignore
    !question.metadata?.hideCondition ||
        !isIdIncludedInAnswers({
            answerId: 
            // @ts-ignore
            question.metadata.hideCondition,
            answers,
        })) {
        acc = [...acc, newItem];
    }
    return acc;
}, []);
export { filteredQuestionsByAnswers };
